import React, { useState } from 'react';
import { Button, FormField, Header, Icon, Input, Modal, ModalActions, ModalContent } from 'semantic-ui-react';
import { updatePassword } from '../../../services/users.service';
import { toast } from 'react-toastify';

interface Props {
    userId: string;
    openModal: boolean;
    onClose: (event: any) => void;
}

const UpdatePasswordModal = ({ userId, openModal, onClose }: Props) => {

    const [ isSubmitting, setIsSubmitting ] = useState(false);
    
    const [ requestData, setRequestData ] = useState({
        newPassword: "",
        confirmPassword: "",
    });

    const handleChange = (e: any, { name, value }: any) => {
        setRequestData({
            ...requestData,
            [name]: value,
        });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {

            if (!userId) {
                throw new Error("El id del usuario no puedo ser obtenido.");
            }

            if (requestData.newPassword !== requestData.confirmPassword) {
                throw new Error("Las contraseñas no coinciden.");
            }

            if (requestData.newPassword && requestData.newPassword.length < 8) {
                throw new Error("La contraseña debe de tener al menos 8 caracteres.");
            }

            const response = await updatePassword(userId, requestData);
            if (response?.status === 204) {
                requestData.newPassword = "";
                requestData.confirmPassword = "";
                toast.success("La contraseña se ha actualizado exitosamente.");
                onClose(e);
            } else {
                throw new Error("Hubo un error al actualizar la contraseña, favor de contactar al area de TI");
            }
        } catch (error: any) {
            toast.error(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Modal
                closeOnDimmerClick
                closeIcon={true}
                size="small"
                onClose={(event) => onClose(event)}
                open={openModal} >
                <Header icon="key" content="Actualizar contraseña" />
                <ModalContent>
                    <div className="ui form">

                        <FormField
                            control={Input}
                            label="Contraseña"
                            placeholder="Añade una contraseña segura"
                            name="newPassword"
                            value={requestData.newPassword}
                            onChange={ handleChange }
                            required
                            type='password'
                            autoComplete="new-password"
                        />

                        <FormField
                            control={Input}
                            label="Confirmar contraseña"
                            placeholder="Introduce la contraseña nuevamente"
                            name="confirmPassword"
                            value={requestData.confirmPassword}
                            onChange={ handleChange }
                            required
                            type='password'
                            autoComplete="new-password"
                        />

                    </div>
                </ModalContent>
                <ModalActions>
                    <Button onClick={ (event) => onClose(event) }>
                        <Icon name="cancel" /> Cancelar
                    </Button>
                    <Button color="green" onClick={ (e) => handleSubmit(e) } disabled={isSubmitting}>
                        <Icon name="checkmark" /> Guardar
                    </Button>
                </ModalActions>
            </Modal>
        </>
    );
};

export default UpdatePasswordModal;
